import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Moon, Sun, Mail, LogOut } from 'lucide-react';
import { useAnalysisInbox } from '../hooks/useAnalysisInbox';
import AnalysisInboxModal from './AnalysisInboxModal';
import { cn } from '../lib/utils';
import { useAuth } from '../contexts/AuthContext';

const FloatingActions = () => {
  const { user, logout } = useAuth();
  const [isDark, setIsDark] = useState(false);
  const [isInboxOpen, setIsInboxOpen] = useState(false);
  const { unreadCount, pendingCount } = useAnalysisInbox();

  // Проверяем текущую тему при загрузке
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const shouldBeDark = savedTheme === 'dark' || (!savedTheme && systemPrefersDark);
    
    setIsDark(shouldBeDark);
    document.documentElement.classList.toggle('dark', shouldBeDark);
  }, []);

  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    
    // Сохраняем в localStorage
    localStorage.setItem('theme', newTheme ? 'dark' : 'light');
    
    // Применяем к документу
    document.documentElement.classList.toggle('dark', newTheme);
  };

  // Показываем badge если есть непрочитанные или pending анализы
  const badgeCount = unreadCount + pendingCount;
  const showBadge = badgeCount > 0;

  return (
    <>
      <div className="fixed bottom-4 right-4 z-50 flex flex-row gap-2">
        {/* Переключатель темы */}
        <Button
          variant="outline"
          size="icon"
          onClick={toggleTheme}
          className="h-10 w-10 rounded-full shadow-lg bg-background border-border hover:bg-accent"
        >
          {isDark ? (
            <Sun className="h-4 w-4" />
          ) : (
            <Moon className="h-4 w-4" />
          )}
        </Button>
        
        {/* Кнопка инбокса */}
        <div className="relative">
          <Button
            variant="outline"
            size="icon"
            onClick={() => setIsInboxOpen(true)}
            className="h-10 w-10 rounded-full shadow-lg bg-background border-border hover:bg-accent"
          >
            <Mail className="h-4 w-4" />
          </Button>
          
          {showBadge && (
            <Badge 
              variant="destructive" 
              className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-xs"
            >
              {badgeCount > 99 ? '99+' : badgeCount}
            </Badge>
          )}
        </div>
        
        {/* Кнопка выхода */}
        {user && (
          <Button
            variant="outline"
            size="icon"
            onClick={logout}
            className="h-10 w-10 rounded-full shadow-lg bg-background border-border hover:bg-accent"
          >
            <LogOut className="h-4 w-4" />
          </Button>
        )}
      </div>

      <AnalysisInboxModal 
        isOpen={isInboxOpen}
        onClose={() => setIsInboxOpen(false)}
      />
    </>
  );
};

export default FloatingActions;
